const DISCLOSURE_VERSION = '2026-07-17';

function clean(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function optional(value) {
  const normalized = clean(value);
  return normalized || null;
}

export function buildLeadPayload(values, context = {}) {
  const locationHref = context.locationHref || (typeof window !== 'undefined' ? window.location.href : 'https://vicsbricks.com/contact');
  const location = new URL(locationHref, 'https://vicsbricks.com');
  const params = location.searchParams;

  return {
    companyWebsite: clean(values.companyWebsite),
    source: {
      site: 'vicsbricks.com',
      funnel: 'masonry-estimate',
      page: location.pathname,
      campaign: optional(params.get('utm_campaign')),
      medium: optional(params.get('utm_medium')),
      term: optional(params.get('utm_term')),
      content: optional(params.get('utm_content')),
      referrer: optional(context.referrer ?? (typeof document !== 'undefined' ? document.referrer : '')),
      landingUrl: location.href,
      userAgent: optional(context.userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '')),
      submittedAtIso: context.submittedAtIso || new Date().toISOString(),
    },
    person: {
      firstName: clean(values.firstName),
      lastName: clean(values.lastName),
      phone: clean(values.phone),
      email: clean(values.email).toLowerCase(),
      preferredContactMethod: clean(values.preferredContactMethod) || 'phone',
      bestTimeToContact: optional(values.bestTimeToContact),
    },
    job: {
      serviceType: clean(values.serviceType),
      urgency: optional(values.urgency),
      homeownerStatus: optional(values.homeownerStatus),
      city: optional(values.city),
      zip: optional(values.zip),
      addressLine1: optional(values.addressLine1),
      message: clean(values.message),
    },
    compliance: {
      consentToContact: values.consentToContact === true,
      disclosureVersion: DISCLOSURE_VERSION,
    },
  };
}

export function makeFallbackEmail(values) {
  const subject = encodeURIComponent(`Project inquiry: ${clean(values.serviceType) || 'Masonry or concrete work'}`);
  const details = [
    `Name: ${clean(values.firstName)} ${clean(values.lastName)}`,
    `Phone: ${clean(values.phone)}`,
    `Email: ${clean(values.email)}`,
    `Location: ${[clean(values.addressLine1), clean(values.city), clean(values.zip)].filter(Boolean).join(', ')}`,
    `Service: ${clean(values.serviceType)}`,
    `Timing: ${clean(values.urgency) || 'Not specified'}`,
    '',
    clean(values.message),
  ].join('\n');
  return `mailto:info@vicsbricks.com?subject=${subject}&body=${encodeURIComponent(details)}`;
}

export async function submitLead(endpoint, payload, signal) {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'omit',
    body: JSON.stringify(payload),
    signal,
  });

  const raw = await response.text();
  let body = null;
  if (raw) {
    try {
      body = JSON.parse(raw);
    } catch {
      body = { error: raw };
    }
  }
  if (!response.ok) {
    const error = new Error(body?.error || 'We could not send your request.');
    error.status = response.status;
    error.details = body?.errors || [];
    throw error;
  }
  return body;
}

